import service from '@/services/SIRsic_ocr_dcli';

export default {
  namespaced: true,

  actions: {
    /** Petición para obtener el NIT de una cuenta. */
    read({ dispatch }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRsic_ocr_dcli: {
            eeDatos: [
              {
                picfiid: values?.token,
                picusrcod: values?.user,
              },
            ],
            eeSIRsic_ocr_dcli: [
              {
                piccia__nit: values?.piccia__nit,
              },
            ],
          },
        };

        let notification;

        service
          .read(payload)
          .then((response) => {
            const data = response.data.dsSIRsic_ocr_dcli;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
